import axios from "axios";
const http = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json", //        'application/json' // multipart/form-data
  },
});

http.interceptors.request.use(
  function (config) {
    if (localStorage.token)
      config.headers.Authorization = "Bearer " + localStorage.token;
    // if (accesstoken) config.headers.accesstoken = accesstoken;

    const url = localStorage.getItem("url");
    if (url) config.baseURL = url;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default http;
